
<template>
  <div>
        <div class="breadcrumb">
            <Breadcrumb>
                <Breadcrumb-item href="#">学生管理</Breadcrumb-item>
                <Breadcrumb-item>分配学导记录</Breadcrumb-item>
            </Breadcrumb>
        </div>
        <div>
            <Form :label-width="100" :show-message="false" label-position="right">
                <Row :gutter="12">
                  <Col :xs="24" :sm="12" :md="6" :lg="6">
                        <Form-item label="分配时间">
                          <Row>
                            <Col>
                              <Date-picker type="date" @on-change="beginTimeChange" format="yyyy-MM-dd" placeholder="请选择日期"/>
                            </Col>
                            <Col >
                              <Date-picker type="date" @on-change="endTimeChange" format="yyyy-MM-dd" placeholder="请选择日期"/>
                            </Col>
                          </Row>
                        </Form-item>
                    </Col>
                  <Col :xs="24" :sm="12" :md="6" :lg="6">
                        <Form-item label="学生">
                          <Input v-model="queryParam.searchIdOrName" placeholder="请输入id或学生名称"></Input>
                        </Form-item>
                    </Col>
                  <Col :xs="24" :sm="12" :md="6" :lg="6">
                    <Form-item label="课程顾问" prop="studyAdviserName">
                      <admin-user-select :status="1" adminGroupCode="adviser" v-model="queryParam.adviserId">
                      </admin-user-select>
                    </Form-item>
                  </Col>
                  <Col :xs="24" :sm="12" :md="6" :lg="6">
                        <Form-item label="原学导">
                          <admin-user-select
                              :status="1"
                              adminGroupCode="userStudyAdviser"
                              v-model="queryParam.oldAdminId"
                          ></admin-user-select>
                        </Form-item>
                    </Col>
                  <Col :xs="24" :sm="12" :md="6" :lg="6">
                        <Form-item label="接收人">
                          <admin-user-select
                              :status="1"
                              adminGroupCode="userStudyAdviser"
                              v-model="queryParam.receiverId"
                          ></admin-user-select>
                        </Form-item>
                    </Col>
                  <Col :xs="24" :sm="12" :md="6" :lg="6">
                        <Form-item label="分配原因">
                          <Select v-model="queryParam.reason" clearable>
                              <Option value="1" key="1">新生分配</Option>
                              <Option value="2" key="2">服务原因更换</Option>
                              <Option value="3" key="3">离职交接</Option>
                          </Select>
                        </Form-item>
                    </Col>
                    <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">搜索</Button>
                    <Button type="primary" :loading="exportLoading" :disable="exportLoading" @click="exportData">导出</Button>
                </Row>
            </Form>
        </div>
        <List ref="dataList" style="margin-top: 10px" :tableColumns="tableColumns" listUrl="/distributionLearnRecord/page"
                :params="queryParam" :onLoading="onLoading" :reload="reload" ></List>
  </div>
</template>

<script>
import { fetchTchScoreMap, renderTchNameWithScore } from '@/utils/tchScore'
export default {
  data () {
    let $constant = this.$constant
    let $moment = this.$moment
    return {
      selectionUser: [],
      reload: 0,
      rankScoreSeq: 0,
      rankScoreMap: {},
      searchLoading: false,
      exportLoading: false,
      queryParam: {
        id: 0,
        uid: 0,
        reason: '',
        oldAdminId: 0,
        oldAdminName: '',
        receiverId: 0,
        receiverName: '',
        distributionId: 0,
        distributionName: '',
        createTime: '',
        updateTime: '',
        beginTime: '',
        beginTimeDate: '',
        endTimeDate: '',
        searchIdOrName: '',
        nickName: '',
        routineNum: 0,
        partnerNum: 0,
        chineseNum: 0,
        routineEndNum: 0,
      },
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '学生ID/姓名',
          // width: 120,
          render: (h, params) => {
            let row = params.row
            return h('span', row.uid + '-' + row.nickName)
          }
        },
        {
          title: '课程顾问',
          width: 120,
          key: 'adviserName'
        },
        {
          title: '课时信息',
          //  width: 180,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let num = row.routineNum - row.routineEndNum
            return h('div', [
              h('div', '外教课课时：' + row.routineNum),
              h('div', '陪练课课时：' + row.partnerNum),
              h('div', '中教课课时：' + row.chineseNum),
              h('div', '外教课课时已消耗：' + row.routineEndNum),
              h('div', '剩余外教课课时：' + num)
            ])
          }
        },
        {
          title: '绑定老师',
          width: 220,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let list = row.bookWorkLessonOpenedTimeList
            if (list.length > 0) {
              let spanArr = []
              const scoreMap = this.rankScoreMap || {}
              list.forEach(function (element) {
                let startTime = $moment.unix(element.startTime).utc().format(' HH:mm')
                spanArr.push(h('span', [
                  renderTchNameWithScore(h, { text: element.tchId + '-' + element.tchName, score: scoreMap[element.tchId] != null ? scoreMap[element.tchId] : scoreMap[String(element.tchId)] }),
                  h('span', '[' + $constant.weekZh[element.week] + startTime + ']')]))
                spanArr.push(h('br'))
              })
              let levelTitle = row.levelTitle
              if (levelTitle) {
                levelTitle = '当前等级：' + levelTitle
              }
              return h('div', {style: {'font-size': '12px'}}, [h('p', levelTitle), h('p', spanArr)])
            } else {
              return h('div', '未绑定')
            }
          }
        },
        {
          title: '分配原因',
          // width: 120,
          align: 'center',
          key: 'intReason',
          render: (h, params) => {
            let row = params.row
            let text = $constant.getEnum($constant.distributionReason, row.intReason).text
            return h('div', text)
          }
        },
        {
          title: '原学导',
          //  width: 120,
          align: 'center',
          key: 'oldAdminName'
        },
        {
          title: '接收人',
          //  width: 120,
          align: 'center',
          key: 'receiverName'
        },
        {
          title: '分配人',
          // width: 120,
          align: 'center',
          key: 'distributionName'
        },
        {
          title: '分配时间',
         // width: 120,
          align: 'center',
          key: 'createTime'
        }
      ]
    }
  },

  created: function () {
  },

  methods: {
    beginTimeChange (value) {
      let self = this
      self.queryParam.beginTimeDate = value
    },
    endTimeChange (value) {
      let self = this
      self.queryParam.endTimeDate = value
    },
        onLoading (loading) {
      this.searchLoading = loading
    
      if (!loading) {
        this.loadBoundTchMonthScores()
      }
    },
    loadBoundTchMonthScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        this.rankScoreMap = {}
        return
      }
      const ids = []
      table.forEach(function (row) {
        const list = row.bookWorkLessonOpenedTimeList || []
        list.forEach(function (el) {
          if (el && el.tchId != null) {
            ids.push(el.tchId)
          }
        })
      })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        self.rankScoreMap = map || {}
      })
    },
    search () {
      this.selectionUser = []
      this.reload = new Date().getTime()
    },
    exportData () {
      this.exportLoading = true
      this.$http.get('/distributionLearnRecord/page-export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '分配学导记录.csv'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// DistributionStudyRecord.vue?4fc5d337